import {useState} from "react";
import {Box, Table, TableBody, TableCell, TableHead, TablePagination, TableRow} from "@mui/material";
import {CampaignRow} from "./CampaignRow";
import {headerCellSx} from "../constants";
import {paginate} from "../utils";

const columns = ["Name", "From number", "Extension", "Dates", "Calling window", "Max attempts", "Phone numbers", "Status", "Created"];

const MessageRow = ({children}) => (
  <TableRow>
    <TableCell colSpan={columns.length + 1} align="center" sx={{py: 6, color: "text.secondary"}}>
      {children}
    </TableCell>
  </TableRow>
);

export const CampaignsTable = ({campaigns, loading, getExtension, onOpen, onEdit, onDelete}) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const {currentPage, pageItems} = paginate(campaigns, page, rowsPerPage);

  return (
    <Box sx={{flex: 1, display: "flex", flexDirection: "column", overflow: "hidden"}}>
      <Box sx={{flex: 1, overflowY: "auto"}}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {columns.map(column => <TableCell key={column} sx={headerCellSx}>{column}</TableCell>)}
              <TableCell padding={"checkbox"} sx={headerCellSx}/>
            </TableRow>
          </TableHead>
          <TableBody>
            {pageItems.map(campaign => (
              <CampaignRow key={campaign.id} campaign={campaign} extension={getExtension(campaign.extensionId)} onOpen={onOpen} onEdit={onEdit} onDelete={onDelete}/>
            ))}
            {campaigns.length === 0 &&
              <MessageRow>{loading ? "Loading..." : "No campaigns yet"}</MessageRow>
            }
          </TableBody>
        </Table>
      </Box>
      <TablePagination
        component="div"
        count={campaigns.length}
        page={currentPage}
        onPageChange={(e, newPage) => setPage(newPage)}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={(e) => {
          setRowsPerPage(parseInt(e.target.value, 10));
          setPage(0);
        }}
        rowsPerPageOptions={[10, 25, 50]}
      />
    </Box>
  )
}
